import script from "./StoreBillStatistic.vue?vue&type=script&lang=ts&setup=true"
export * from "./StoreBillStatistic.vue?vue&type=script&lang=ts&setup=true"

import "./StoreBillStatistic.vue?vue&type=style&index=0&id=6c794aeb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c794aeb"]])

export default __exports__